const common = {
    language: {
        bg: 'BG',
        en: 'EN',
        switchLabel: 'Смени език',
    },
    actions: {
        close: 'Затвори',
    },
    eventDate: {
        day: '26',
        month: 'септември',
    },
    nav: {
        admin: 'Админ',
        conditions: 'Условия за участие',
        courses: 'Информация за трасетата',
        home: 'Начало',
        participants: 'Участници',
        payment: 'Плащане',
        register: 'Регистрирай се',
        results: 'Класиране',
        toggleMenu: 'Отвори меню',
        records: 'Рекорди',
    },
};

export default common;
